/**
 * Shared question card used across discovery sections.
 * accent is a CSS color string (e.g. "#F57F17").
 */
export default function QuestionCard({ q, f, i = 0, accent = "#F57F17" }) {
  return (
    <article
      data-testid={`question-card-${i}`}
      className="reveal pl-6 sm:pl-7 py-2 border-l-[3px]"
      style={{ borderColor: accent, transitionDelay: `${(i % 2) * 80}ms` }}
    >
      <h3 className="font-serif-d text-[22px] sm:text-[26px] leading-[1.25] text-[#0D1B2A]">
        {q}
      </h3>
      <p className="mt-4 text-[16px] text-[#5C6470] leading-[1.65] max-w-xl">{f}</p>
    </article>
  );
}
